import React, { useContext, useState } from 'react'
import axios from 'axios'
import { get } from 'lodash'
import { BookInfo, SelectionContext, UserInfo } from '../../contexts/menuContext'
import EditAnnotation from './annotation-edit'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


// eslint-disable-next-line react/prop-types
const AnnotationItem = ({ fromNow, json, setReload, converter, obj, removable = false }) => {
  const [, , page, setPage, , setForceScroll,,, csrfToken] = useContext(BookInfo)
  const [user, setUser] = useContext(UserInfo)
  const [, setSelection] = useContext(SelectionContext)
  const [status, setStatus] = useState(false)
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div
      className="annotation-block"
    >
      <div className="annotation-block--header">
        <span className="annotation-block--header-name">{get(obj, 'author.name', 'none')}</span>
        <span className="annotation-block--header-data">{fromNow}</span>
      </div>
      <div className="annotation-block--content">
        <blockquote
          onClick={(e) => {
            e.stopPropagation()
            setForceScroll(true)
            setPage(page)
            if (get(json, 'quote', false)) {
              const content = document.querySelector(`.book .page[data-id="${page}"]`);
              const startPos = content.textContent.indexOf(json.quote)
              setSelection( {selection: {start: startPos, end: startPos + json.quote.length}, page, text: json.quote})
            }
            else {
              setSelection({ ...json, page })
            }
          }}
          className="annotation-block--quote">{json.text ? json.text : json.quote}</blockquote>
        {status ? <EditAnnotation
          setReload={setReload}
          annotationObj={json.text}
          content={obj.content}
          defaults={obj}
          page={page}
          setStatus={setStatus}
        /> : <div
          className="annotation-block--comment"
          dangerouslySetInnerHTML={{ __html: converter.makeHtml(obj.content) }}
        /> }
      </div>
      {
        get(user, 'id') === get(obj, 'author.id') &&
        <>
          <button
            type="button"
            className="btn btn-light annotation-block-edit"
            onClick={() => { setStatus(true) }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              aria-hidden="true"
              focusable="false"
              className=""
            >
              <g fillRule="evenodd">
                <rect fill="none" stroke="none" x="0" y="0" width="16" height="16" />
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 4l1 1-9 9-2 1 1-2 9-9zm3-3l1 1-1 1-1-1 1-1z"
                />
              </g>
            </svg>
          </button>
          <button
            type="button"
            className="btn btn-light annotation-block-remove"
            onClick={handleClickOpen}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              aria-hidden="true"
              focusable="false"
              className=""
            >
              <g fillRule="evenodd">
                <rect fill="none" stroke="none" x="0" y="0" width="16" height="16" />
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M2 4h12l-2 11H4L2 4zM1 1h14H1z"
                />
              </g>
            </svg>
          </button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                This action can't do be undone. All the information will be removed.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={() => {
                axios.delete(`/bookreader/toolbox/annotation/${get(obj, 'id')}`, {
                  headers: {
                    'X-CSRF-Token': csrfToken
                  }
                }).then(((res) => {
                  setReload(Date.now())
                  setSelection({})
                  if (removable) {
                    const newUserObj = {...user};
                    newUserObj.annotations = newUserObj.annotations.filter((i) => {
                      return i !== get(obj, 'subsectionId')
                    });
                    setUser(newUserObj)
                  }
                }))
              }} color="primary" autoFocus>
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }

    </div>
  )
}

export default AnnotationItem
